



















































































































































































































































































































































































import Vue from 'vue'
import { getOrderList, addBackCart } from '@/api/order'
import { IOrderCartList, IOrderCartItem, IOrderDetails, IOrderButtonsMap } from '@/interfaces/order'
import DescriptionElement from '@/components/DescriptionElement.vue'
import EmptyBox from '@/components/EmptyBox.vue'
import postAppMessage, { MessageHandlers } from '@/utils/poster'
import { MetaInfo } from 'vue-meta/types/vue-meta'
import moment from 'moment'

interface IConvertedCartItem extends IOrderCartItem {
  productId: number
}

export default Vue.extend({
  name: 'Order',
  components: { DescriptionElement, EmptyBox },
  data () {
    return {
      isShowingAllCartItems: false,
      isShowToast: false,
      isLoading: false,
      isLoadedOrder: false,
      orderList: [] as IOrderDetails[],
      cartItemsArray: [] as IConvertedCartItem[][],
      buttonsMap: null as IOrderButtonsMap | null,
      currentExapandedIndex: null as number | null,
      copiedShow: false as boolean,
      currentPage: 1,
      perPageOrder: 10
    }
  },
  metaInfo (): MetaInfo {
    return {
      title: '查詢訂單',
      titleTemplate: '%s | nuPhoto 拍立洗'
    }
  },
  computed: {
    getCurrentPageOrderList (): IOrderDetails[] {
      const orderCount = this.orderList.length % this.perPageOrder
      const pagesCount = Math.ceil(this.orderList.length / this.perPageOrder)
      const lastPage = pagesCount
      const start = this.perPageOrder * (this.currentPage - 1)
      if (orderCount !== 0) { if (lastPage === this.currentPage) { return this.orderList.slice(start, start + orderCount) } }
      return this.orderList.slice(start, start + this.perPageOrder)
    }
  },
  created () {
    window.handleGetOrderList = this.handleGetOrderList
    this.$on('loadData', () => { this.handleGetOrderList() })
    this.handleGetOrderList()
  },
  methods: {
    async handleGetOrderList () {
      this.$store.commit('SET_FOOTER', false)
      this.isLoading = true
      this.isLoadedOrder = false
      this.orderList = []
      this.cartItemsArray = []
      try {
        const token = this.$store.getters.isWebViewMode ? this.$route.query.token || this.$store.getters.token : this.$store.getters.token
        const { data } = await getOrderList({ token, extra: 1 })
        if (data.flag === 0) {
          const payload = data.data
          console.log(`Order: ${moment().format('YYYY/MM/DD HH:mm:ss.SSS')}`)
          this.orderList = payload.order_list || []
          this.buttonsMap = payload.button_map
          this.orderList.forEach((order) => {
            this.convertCartListFromObjectToArray(order.cart_list)
          })
        }
      } catch (error) {
        console.log(error)
        this.$bvModal.msgBoxConfirm(`${error.message}是否要重新讀取？`, {
          centered: true,
          noCloseOnBackdrop: true,
          noCloseOnEsc: true,
          footerClass: 'msgbox-confirm-footer',
          cancelTitle: '否',
          okTitle: '是'
        }).then((result) => {
          if (result) this.handleGetOrderList()
        })
      } finally {
        this.isLoading = false
        this.isLoadedOrder = true
        this.$store.commit('SET_FOOTER', true)
      }
    },
    convertCartListFromObjectToArray (cartList: IOrderCartList) {
      const tempArray = [] as IConvertedCartItem[]
      for (const key of Object.keys(cartList)) {
        tempArray.push({ productId: parseInt(key), ...cartList[key] })
      }
      this.cartItemsArray.push(tempArray)
    },
    stackedCartItem (orderIndex: number): IConvertedCartItem {
      return this.cartItemsArray[(this.currentPage - 1) * this.perPageOrder + orderIndex][0]
    },
    collapsedCartItems (orderIndex: number) : IConvertedCartItem[] {
      return this.cartItemsArray[(this.currentPage - 1) * this.perPageOrder + orderIndex].slice(1)
    },
    onCollapseOrderChanged (orderIndex: number) {
      if (this.currentExapandedIndex === orderIndex) {
        this.currentExapandedIndex = null
      } else {
        this.currentExapandedIndex = orderIndex
      }
    },
    onCopyClicked (text: string) {
      navigator.clipboard.writeText(text)
        .then(() => {
          this.copiedShow = true
          setTimeout(() => { this.copiedShow = false }, 500)
        })
        .catch((error) => { console.error(`Copy failed! ${error}`) })
    },
    onCartItemTitleClicked (cartItem: IOrderCartItem) {
      if (this.$store.getters.isWebViewMode) {
        postAppMessage(MessageHandlers.NAVIGATE_TO_PRODUCT, cartItem.product_id.toString())
      } else {
        this.$router.push({ name: 'Product', params: { productId: cartItem.product_id.toString() } })
      }
    },
    onCartItemImageClicked (cartItem: IOrderCartItem) {
      if (cartItem.photo_product === 1) {
        this.$router.push({ name: 'OrderDetails', params: { orderId: cartItem.id || '' } })
      } else {
        if (this.$store.getters.isWebViewMode) {
          postAppMessage(MessageHandlers.NAVIGATE_TO_PRODUCT, cartItem.product_id.toString())
        } else {
          this.$router.push({ name: 'Product', params: { productId: cartItem.product_id.toString() } })
        }
      }
    },
    async handleAddBackToCart (orderId: number | string) {
      this.isLoading = true
      try {
        const token = this.$store.getters.isWebViewMode ? this.$route.query.token || this.$store.getters.token : this.$store.getters.token
        const requestBody = {
          token,
          order_id: orderId.toString()
        }
        const { data } = await addBackCart(requestBody)
        this.isLoading = false
        if (data.flag === 0) {
          this.$store.commit('SET_CART_COUNT', data.count)
          this.notifyAppToUpdateCartBadge(data.count)
          this.popToast()
        } else {
          this.$bvModal.msgBoxOk(data.msg, {
            centered: true,
            footerClass: 'msgbox-ok-footer',
            okTitle: '確定'
          })
        }
      } catch (error) {
        this.isLoading = false
        console.log(error)
        this.$store.dispatch('logger/PUSH_LOG', error)
        this.$bvModal.msgBoxConfirm(`${error.message}是否要再試一次？`, {
          centered: true,
          noCloseOnBackdrop: true,
          noCloseOnEsc: true,
          footerClass: 'msgbox-confirm-footer',
          cancelTitle: '否',
          okTitle: '是'
        }).then((result) => {
          if (result) this.handleAddBackToCart(orderId)
        })
      }
    },
    popToast () {
      this.isShowToast = true
      setTimeout(() => { this.isShowToast = false }, 2000)
    },
    onPageClicked () {
      if (this.currentExapandedIndex !== null) {
        this.$root.$emit('bv::toggle::collapse', `collapse-cart-items-${this.currentExapandedIndex}`)
        this.$root.$emit('bv::toggle::collapse', `collapse-amount-details-${this.currentExapandedIndex}`)
        this.$root.$emit('bv::toggle::collapse', `collapse-info-${this.currentExapandedIndex}`)
        this.$root.$emit('bv::toggle::collapse', `collapse-hint-${this.currentExapandedIndex}`)
        this.$root.$emit('bv::toggle::collapse', `collapse-delivery-${this.currentExapandedIndex}`)
        this.currentExapandedIndex = null
      }
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    notifyAppToUpdateCartBadge (count: number) {
      postAppMessage(MessageHandlers.UPDATE_CART_BADGE, count)
    }
  }
})
